import { TStiReportData } from '@infotech-soe/merps';

import {
  BuiltinCaptionType,
  CaptionType,
} from '../../../models/caption/Caption';
import { FormTitle } from '../FormTitle';
import { FormControlViewModelType } from '../view-model/FormControlViewModel';
import { PredefinedForms } from '../view-model/FormCreateViewModel';

import {
  AbstractPredefinedFormSchemaFactory,
  IExtendedFormParsed,
} from './FormSchemaFactory';

class ReviewFormSchemaFactory implements AbstractPredefinedFormSchemaFactory<PredefinedForms.REVIEW> {
  public getTitle(): FormTitle {
    return { type: CaptionType.BUILT_IN, caption: BuiltinCaptionType.REVIEW };
  }

  public async getFormSchema(
    template: string,
    data: TStiReportData['data'],
    variables?: Record<string, any>
  ): Promise<IExtendedFormParsed> {
    return {
      Layout: [
        {
          control: FormControlViewModelType.REPORT,
          name: 'report',
          template,
          value: JSON.stringify(data),
          variables,
        },
      ],
      Fields: {},
    };
  }
}

export default ReviewFormSchemaFactory;
